<template>
  <div class="mini-mask" @click="showTips=false">
    <div class="mini">
      <div class="mini-close iconfont icon-guanbi" @click="closeLogin"></div>
      <div class="mini-content">
        <div class="mini-login-wrapper">
          <div class="mini-tab">
            <span class="mini-tab-password" :class="loginType==='password'?'isActive':''" @click="loginType='password'"> 密码登录 </span>
            <span class="mini-tab-line"></span>
            <span class="mini-tab-message" :class="loginType==='message'?'isActive':''" @click="loginType='message'"> 短信登录 </span>
          </div>
          <div class="mini-password-wrapper" v-if="loginType==='password'">
            <div class="mini-account">
              <span class="text">账号</span>
              <input type="text" placeholder="请输入账号" v-model="username" @keyup.enter="passwordLogin">
            </div>
            <div class="mini-password">
              <div class="left">
                <span class="text">密码</span>
                <input type="password" placeholder="请输入密码" v-model="password" @keyup.enter="passwordLogin">
              </div>
              <span class="forget" @click.stop="showTips=true"> 忘记密码？ </span>
              <div class="forget-tip" v-if="showTips">
<!--                <img src="https://s1.hdslb.com/bfs/seed/jinkela/short/mini-login/img/arrow.fa71fe60.png" alt=""-->
<!--                     class="arrow">-->
                <div class="forget-tip-line" @click="loginType='message'">
                  <p class="title">发送短信快速登录</p>
                  <p class="desc">未注册或绑定iiucas的手机号，将帮你注册新账号</p>
                </div>
                <div class="forget-tip-line" @click="toForgetPage">
                  <p class="title">去找回密码</p>
                  <p class="desc">通过绑定的手机号/邮箱重置密码</p>
                </div>
              </div>
            </div>
          </div>
          <div class="mini-message-wrapper" v-else>
            <div class="mini-tel">
              <div class="mini-tel_left">
                <div class="el-select"><!---->
                +86</div>
                <input placeholder="请输入手机号" class="tel-input" v-model="username" @keyup.enter="messageLogin"></div>
              <div class="mini-tel_right">
                <span class="line"></span>
                <span class="text" @click="seedMessage">{{ getMessageText }}</span>
              </div>
            </div>
            <div class="mini-code">
              <span class="text">验证码</span>
              <input placeholder="请输入验证码" v-model="code" @keyup.enter="messageLogin"></div>
          </div>
          <div class="mini-login-register-wrapper">
            <div class="universal-btn login-btn" v-if="loginType==='message'" @click="messageLogin"> 登录 / 注册 </div>
            <div class="universal-btn register-btn" v-if="loginType==='password'" @click="loginType='message'"> 注册</div>
            <div class="universal-btn login-btn" v-if="loginType==='password'" @click="passwordLogin"> 登录</div>
          </div>
          <div class="third-party-login-wrapper">
            <div class="title">其他方式登录</div>
            <div class="sns">
              <a class="btn wechat" href="https://uukasi.com/wx_login/?state=1-new"><i class="iconfont icon-weixin-copy"></i>微信登录</a>
              <a class="btn weibo" href="https://uukasi.com/wb_login/?state=1-new"><i class="iconfont icon-weibo-copy"></i>微博登录</a>
              <a class="btn qq" href="https://uukasi.com/qq_login/?state=1-new"><i class="iconfont icon-QQ-circle-fill"></i>QQ登录</a>
            </div>
          </div>
        </div>
      </div>
      <div class="mini-agreement-wrapper">
        <div class="mini-agreement-content">
          <p>未注册过iiucas的手机号，我们将自动帮你注册账号</p>
          <p>登录或完成注册即代表你同意
            <a target="_blank" href=""> 用户协议 </a>和 <a
              target="_blank" href=""> 隐私政策 </a></p>
        </div>
      </div><!----><!---->
      <div style="background: rgba(0,0,0,.5);width: 100%;height: 100%;position: absolute;top: 0;left: 0;" v-if="showVerification">
        <VerificationText></VerificationText>
      </div>
    </div>
  </div>
</template>

<script>
import {
  errorManageList,
  getUserDetail, getUserIp,
  login,
  loginCodes, userDevice,
  verifyLogin,

} from "../config/axiosUtil";
import VerificationText from "./verificationText";

export default {
  name: "loginPage",
  data(){
    return{
      showTips: false,
      loginType: 'password',
      username: '',
      password: '',
      code: '',
      countdownTime: 60,
      getMessageText:'获取验证码',
      showVerification: false,
      errorNum: 0,
      times: 5*60,
      verManage:{
        showVer:3,
        showError: 10,
        waitTime: 5,
      },
    }
  },
  mounted() {
    this.getManage()
  },
  methods: {
    getManage(){
      errorManageList().then(data=>{
        if(data.data.length>0){
          this.verManage = data.data[0]
          this.times = this.verManage.waitTime*60
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    passwordLogin(){
      let timer
      function timeReload(seconds){
        var mm
        var ss
        if (seconds == null || seconds <= 0) {
          return '00m00s'
        }
        mm = seconds / 60 | 0
        ss = parseInt(seconds) - mm * 60
        if (parseInt(mm) < 10) {
          mm = '0' + mm
        }
        if (ss < 10) {
          ss = '0' + ss
        }
        return mm + '分' + ss + '秒'
      }
      if(this.errorShow){
        this.$message.warning(`请${timeReload(this.times)}后再次点击登录`)
        return;
      }
      let that = this
      if(!this.username) {
        this.$message.warning('账号不得为空')
        return
      }else if(!this.password){
        this.$message.warning('密码不得为空')
        return;
      }
      let params = new URLSearchParams()
      params.append('username', this.username)
      params.append('password', this.password)
      login(params)
        .then((response)=> {
          if(response.data.status==='0'){
            localStorage.setItem('iiucasToken',response.data.data.token)
            this.getUserDetailFun()
          }else{
            this.errorNum++
            if(this.errorNum===this.verManage.showError){
              this.$message.error(response.data.data.error+`,请${timeReload(this.verManage.waitTime*60)}后再次点击登录`);
              this.errorShow = true
              timer = setInterval(() => {
                that.times--
                if (that.times === 0) {
                  clearInterval(timer)
                  that.errorShow = false
                  that.errorNum = 0
                  that.times = that.verManage.waitTime*60
                }
              }, 1000)
            }else if(this.errorNum===this.verManage.showVer){
              this.$message.error(response.data.data.error+',前往验证');
              this.showVerification = true
            }else {
              this.$message.error(response.data.data.error);
            }
          }
        })
        .catch(function (error) {
          this.$message.error(error);
        });
    },
    seedMessage() {       //发送短信验证码
      var that = this
      if (that.countdownTime!==60){
        console.log(that.countdownTime)
        return;
      }
      //手机号
      var reP = /^1\d{10}$/;
      if(!reP.test(that.username)){
        that.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        });
        return;
      }
      // return;
      //开启倒计时
      loginCodes({            //短信验证码登录接口
        username:that.username,
      })
        .then(response=> {
          if(response.data.status === '0'){
            that.$message({
              message: '验证码发送成功',
              type: 'success'
            });
          }else{
            that.$message.error(response.data.data.error);
          }
        })
        .catch(function (error) {
          that.$message.error(error);
        });
      settime()
      function settime() {
        if (that.countdownTime === 0) {

          that.getMessageText="获取验证码";
          that.countdownTime = 60;
          return;
        }else {
          that.getMessageText="重新发送(" + that.countdownTime + ")";
          that.countdownTime--;
        }
        setTimeout(function() {
          settime()
        },1000)
      }
    },
    messageLogin(){
      var that = this
      if(that.username==="" || that.code===""){
        that.$message({
          message: '请输入用户名和验证码',
          type: 'warning'
        });
        return;
      }
      var params = new URLSearchParams()
      params.append('username', that.username)
      params.append('code', that.code)
      verifyLogin(params)
        .then((response)=> {          //短信验证登录接口
          if(response.data.status==='0'){
            if(response.data.data.next==="login"){
              localStorage.setItem('iiucasToken',response.data.data.token)
              that.getUserDetailFun();
            }else{
              that.getUserDetailFun()
            }
          }else{
            that.$message.error(response.data.data.error);
          }
        })
        .catch(function (error) {
          that.$message.error(error);
        });
    },
    getUserDetailFun(){
      getUserDetail({     //查询用户信息接口
        username:this.username,
        types: 'new'
      })
        .then(function (response) {
          if(response.data.status==='0'){
            localStorage.setItem('userInfo',JSON.stringify(response.data.data))
            localStorage.setItem('lastPost', Date.now())
            this.$store.dispatch('setInfo')
            this.username = ""
            this.password = ""
            this.code = ''
            //调用父组件
            sessionStorage.setItem('forumLogin',true)              //为了论坛数据
            this.$parent.showLogin = false
            this.sendUserDevice()
          }
        }.bind(this))
        .catch(err=> console.log(err))
      getUserIp().then(data=>{

      }).catch(err=>{
        console.log(err)
      })

    },
    sendUserDevice(){
      let device
      var isPhone = /mobile/i.test(navigator.userAgent);
      //如果包含“Mobile”（是手机设备）则返回true
      if(!isPhone){
        device = 'h5'
      }
      //  苹果手机
      if (navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad')) {
        // // 获取设备名
        // if (navigator.userAgent.includes('iPad')) {
        //   device = 'iPad'
        // } else {
        //   device = 'iPhone'
        // }
        // 获取操作系统版本
        let m1 = navigator.userAgent.match(/iPhone OS .*?(?= )/)
        if (m1 && m1.length > 0) {
          device = m1[0]
          // console.log(webLog.system)
        }
      }
      // 安卓手机
      if (navigator.userAgent.includes('Android')) {
        // 获取设备名
        // let m1 = navigator.userAgent.match(/Android.*; ?(.*(?= Build))/)
        // if (m1 && m1.length > 1) {
        //   device = m1[1]
        //   // console.log(webLog.device)
        // }
        // 获取操作系统版本
        let m1 = navigator.userAgent.match(/Android.*?(?=;)/)
        if (m1 && m1.length > 0) {
          device = m1[0]
        }
      }
      // console.log(webLog)

      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      // var type = connection.type;
      let network = ''
      let address = ''
      if(connection){
        network = connection.type || connection.effectiveType
      }

      // // 页面加载时执行getLocation函数
      // getLocation()
      // if (supportsGeoLocation()) {
      //   console.log("你的浏览器支持 GeoLocation.");
      // } else {
      //   console.log("不支持 GeoLocation.")
      // }
      // // 检测浏览器是否支持HTML5
      // function supportsGeoLocation() {
      //   return !!navigator.geolocation;
      // }
      // // 单次位置请求执行的函数
      // function getLocation() {
      //   navigator.geolocation.getCurrentPosition(mapIt, locationError);
      // }
      // //定位成功时，执行的函数
      // function mapIt(position) {
      //   console.log(position)
      //   let lon = position.coords.longitude;
      //   let lat = position.coords.latitude;
      //   let latlon = lon + "," + lat;
      //   // alert("您位置的经度是：" + lon + " 纬度是：" + lat);
      //
      //   // 创建地理编码（地理解析器）实例
      //   var myGeo = new BMap.Geocoder();
      //   // 根据坐标得到地址描述    下面输入坐标。
      //   myGeo.getLocation(new BMap.Point(lon, lat), function (result) {
      //     if (result) {
      //       console.log(result);
      //       console.log(JSON.stringify(result.addressComponents));
      //     }
      //   });
      // }
      //
      // // 定位失败时，执行的函数
      // function locationError(error) {
      //   console.log(error);
      //   switch (error.code) {
      //     case error.PERMISSION_DENIED:
      //       console.log("无法定位.");
      //       break;
      //     case error.POSITION_UNAVAILABLE:
      //       console.log("位置信息不可用.");
      //       break;
      //     case error.TIMEOUT:
      //       console.log("请求超时.");
      //       break;
      //     case error.UNKNOWN_ERROR:
      //       console.log("未知错误.");
      //       break;
      //   }
      // }

      let params = new FormData()
      params.append('types', 'login')
      params.append('device', device)
      params.append('network', network)
      params.append('address', address)
      params.append('lastTime', new Date())
      userDevice(params).then(response=>{
        location.reload()
      }).catch(err=>{

      })

    },
    toForgetPage(){

    },
    QQLogin(){
      let href = 'https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101461121&response_type=code&redirect_uri=http%3a%2f%2fwww.uukasi.com%2fcomplete%2fqq&scope=get_user_info&state=1-new'
      window.open(href, '_target')
    },
    WBLogin(){
      let href = 'https://api.weibo.com/oauth2/authorize?client_id=1340112531&response_type=code&redirect_uri=https://uukasi.com/complete/weibo&scope=get_user_info&state=1-new'
      window.open(href, '_target')
    },
    WechatLogin(){
      let href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wxe149574a60547d00&redirect_uri=https://uukasi.com/complete/weixin&response_type=code&scope=snsapi_login&state=1-new#wechat_redirect'
      window.open(href, '_target')
    },
    closeLogin(){
      this.$parent.showLogin = false
    },
  },
  components: {
    VerificationText,
  }
}
</script>

<style scoped>
@import "../assets/css/modules/loginPage.css";
</style>



// WEBPACK FOOTER //
// src/components/loginPage.vue